import React, { useEffect, useState, useContext, useRef } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import jsPDF from "jspdf";
import { AppContext } from "../utilities/context";
// import { isEmpty } from "../utilities/helpers";
import Container from "@mui/material/Container";
import Layout from "./Layout";
import { Grid, Typography } from "@mui/material";
import { FormattedMessage, useIntl } from "react-intl";
import TextField from "@mui/material/TextField";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import Button from "@mui/material/Button";
import CloseIcon from "@mui/icons-material/Close";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import SaveIcon from "@mui/icons-material/Save";
import L from "leaflet";
import { MapContainer, TileLayer, Marker, Popup, useMap } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import mrkricon from "leaflet/dist/images/marker-icon.png";
import mrkriconShadow from "leaflet/dist/images/marker-shadow.png";
import QRCode from "qrcode";
import backQR from "../../public/assets/images/detailLogoBig.png";
import TelegramIcon from "@mui/icons-material/Telegram";
import DownloadIcon from "@mui/icons-material/Download";
import Switch from "@mui/material/Switch";
import FormControl from "@mui/material/FormControl";
import FormGroup from "@mui/material/FormGroup";
import FormLabel from "@mui/material/FormLabel";
import FormControlLabel from "@mui/material/FormControlLabel";

const DefaultIcon = L.icon({
  iconUrl: mrkricon,
  shadowUrl: mrkriconShadow,
  iconSize: [25, 41],
  iconAnchor: [12, 41],
});
L.Marker.prototype.options.icon = DefaultIcon;

const MapUpdater = ({ doorLat, doorLng }) => {
  const map = useMap();
  useEffect(() => {
    if (doorLat && doorLng) {
      map.setView([doorLat, doorLng], 13);
    }
  }, [doorLat, doorLng, map]);
  return null;
};

const DoorForm = ({ doorName, handleNameChange, inputNameRef, intl }) => (
  <TextField
    ref={inputNameRef}
    id="outlined-basic"
    label={intl.formatMessage({ id: "app.ring.form.doorName.label" })}
    variant="outlined"
    name="name"
    onChange={handleNameChange}
    value={doorName}
    fullWidth
  />
);

const MapSection = ({ mapRef, doorLat, doorLng, centerPoint }) => (
  <MapContainer
    id={"ringMapContainer"}
    ref={mapRef}
    // style={{ width: "500px", height: "500px" }}
    center={centerPoint}
    zoom={13}
  >
    <TileLayer
      attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
      url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
    />
    <MapUpdater doorLat={doorLat} doorLng={doorLng} />
    {doorLat && doorLng && (
      <Marker position={[doorLat, doorLng]}>
        <Popup>
          Nueva posición del QR: {doorLat.toFixed(5)}, {doorLng.toFixed(5)}
        </Popup>
      </Marker>
    )}
  </MapContainer>
);

const Detail = ({
  inputNameRef,
  door,
  doorName,
  mapRef,
  doorLat,
  doorLng,
  locateQr,
  syncDoor,
  handleNameChange,
  canvasRef,
  closeCard,
  handleChangeActive,
  switchRef,
  intl,
}) => {
  const ringLink =
    process.env.REACT_APP_FRONT_URL + "/qr/" + (door ? door.hashId : "");

  const label = { inputProps: { "aria-label": "Switch demo" } };

  useEffect(() => {
    const mainCanvas = canvasRef.current;
    if (!door || !canvasRef.current) return;
    const ctx = mainCanvas.getContext("2d");
    const canvasWidth = 900;
    const canvasHeight = 900;
    const qrSize = 460;
    const textHeight = 50;
    mainCanvas.width = canvasWidth;
    mainCanvas.height = canvasHeight;

    const backgroundImage = new Image();
    backgroundImage.src = backQR;
    backgroundImage.onload = () => {
      ctx.drawImage(backgroundImage, 0, textHeight, canvasWidth, canvasHeight);

      ctx.font = "bold 80px Roboto";
      ctx.fillStyle = "black";
      ctx.textAlign = "center";
      ctx.fillText(
        intl.formatMessage({ id: "app.ring.qr.label" }),
        canvasWidth / 2,
        70
      );

      const qrCanvas = document.createElement("canvas");
      QRCode.toCanvas(
        qrCanvas,
        ringLink,
        { width: qrSize, margin: 1 },
        (error) => {
          if (error) console.error(error);
          ctx.drawImage(
            qrCanvas,
            (canvasWidth - qrSize) / 2,
            (canvasHeight - qrSize) / 2 + textHeight
          );
        }
      );
    };
  }, [door]);

  // centimetres
  const marginTop = 2;
  const marginLeft = 2;
  const qrWidth = 6;
  const qrHeight = 6;
  const downloadQr = () => {
    const mainCanvas = canvasRef.current;
    if (mainCanvas) {
      const dataUrl = mainCanvas.toDataURL("image/png");

      // Create a jsPDF instance
      const pdf = new jsPDF({
        orientation: "portrait",
        unit: "cm",
        format: [qrWidth + marginLeft * 2, qrHeight + marginTop * 2], // Define the size as 6x6 cm
      });

      // Add the image to the PDF with dimensions 6x6 cm
      pdf.addImage(dataUrl, "PNG", marginLeft, marginTop, qrWidth, qrHeight);

      // Save the PDF
      pdf.save("QR_Code.pdf");
    }
  };

  const centerPoint = door?.lat && door?.lng ? [door.lat, door.lng] : [0, 0];

  return door ? (
    <Grid item key={"g" + door.id} xs={12} sm={12} md={12} lg={12}>
      <Card key={"gc" + door.id} sx={{ minWidth: 275 }}>
        <CardContent key={"gcc" + door.id}>
          <div
            style={{
              with: "100%",
              position: "relative",
              height: "24px",
              marginBottom: "16px",
            }}
          >
            <CloseIcon
              style={{ position: "absolute", right: "0", cursor: "pointer" }}
              onClick={closeCard}
            />
          </div>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <DoorForm
                doorName={doorName ? doorName : door.name}
                handleNameChange={handleNameChange}
                inputNameRef={inputNameRef}
                intl={intl}
              />
            </Grid>
            <Grid item xs={12}>
              <Button
                component={Link}
                to={
                  "https://t.me/" +
                  process.env.REACT_APP_BOT_URL +
                  "?start=" +
                  (door ? door.hashId : "")
                }
                target="_blank"
                variant="contained"
                color="primary"
              >
                <TelegramIcon />
                <FormattedMessage id="app.ring.form.syncTelegram.label" />
              </Button>
            </Grid>
            <Grid item xs={12}>
              <FormControl component="fieldset">
                <FormLabel component="legend">
                  <FormattedMessage id="app.ring.form.active.label" />
                </FormLabel>
                <FormGroup aria-label="position" row>
                  <FormControlLabel
                    value="bottom"
                    control={
                      <Switch
                        ref={switchRef}
                        {...label}
                        onChange={handleChangeActive}
                        defaultChecked={door.active ? true : false}
                        inputProps={{ name: "doorActive" }}
                      />
                    }
                  />
                </FormGroup>
              </FormControl>
            </Grid>
            <Grid item xs={12} md={6}>
              <div>
                <Button onClick={downloadQr} variant="outlined" color="primary">
                  <DownloadIcon />
                  <FormattedMessage id="app.ring.form.download.label" />
                </Button>
                <canvas
                  ref={canvasRef}
                  style={{
                    display: "block",
                    margin: "auto",
                    width: "300px",
                    height: "300px",
                  }}
                ></canvas>
              </div>
            </Grid>
            <Grid item xs={12} md={6}>
              <Button variant="outlined" size="small" onClick={locateQr}>
                <LocationOnIcon />
                <FormattedMessage id="app.ring.form.locateQR.label" />
              </Button>
              <div className="mapContainer">
                <MapSection
                  mapRef={mapRef}
                  doorLat={doorLat}
                  doorLng={doorLng}
                  centerPoint={centerPoint}
                />
              </div>
            </Grid>
          </Grid>
        </CardContent>
        <CardActions sx={{ textAlign: "right" }}>
          <Button variant="outlined" size="small" onClick={syncDoor}>
            <SaveIcon />
            <FormattedMessage id="app.ring.form.save.label" />
          </Button>
        </CardActions>
      </Card>
    </Grid>
  ) : (
    <Grid item>Loading...</Grid>
  );
};

const RingDetail = () => {
  const intl = useIntl();
  const [value, setValue] = useState(false);
  const context = useContext(AppContext);
  const canvasRef = useRef(null);
  const navigate = useNavigate();
  const urlParams = useParams();
  const mapRef = useRef(null);
  const inputNameRef = useRef(null);
  const [door, setDoor] = useState(null);
  const [doorName, setDoorName] = useState("");
  const [doorLat, setDoorLat] = useState(null);
  const [doorLng, setDoorLng] = useState(null);
  const [doorActive, setDoorActive] = useState(false);
  const switchRef = useRef(null);

  const closeCard = () => {
    navigate("/ring");
  };

  useEffect(() => {
    if (context) {
      context.updateBreadcrumbsState([
        {
          label: intl.formatMessage({ id: "app.header.home.label" }),
          url: "/",
        },
        {
          label: intl.formatMessage({ id: "app.header.ring.label" }),
          url: "/ring",
        },
      ]);
    }

    axios
      .get(`${process.env.REACT_APP_API_URL}/api/ring/${urlParams.ringId}`)
      .then((response) => {
        setDoor(response.data);
        setDoorLat(response.data.lat);
        setDoorLng(response.data.lng);
        setDoorActive(response.data.active);
      })
      .catch(() => setDoor(null));
  }, [urlParams.ringId]);

  const locateQr = () => {
    navigator.geolocation.getCurrentPosition(
      ({ coords: { latitude, longitude } }) => {
        setDoorLat(latitude);
        setDoorLng(longitude);
      },
      (error) => console.error("Error obteniendo la ubicación:", error)
    );
  };

  const handleNameChange = (e) => {
    setDoorName(e.target.value);
  };

  const handleChangeActive = (e) => {
    setDoorActive(e.target.checked);
  };

  const syncDoor = () => {
    const updatedDoor = {
      ...door,
      name: doorName || door.name,
      lat: doorLat || door.lat,
      lng: doorLng || door.lng,
      active: doorActive,
    };
    axios
      .put(`${process.env.REACT_APP_API_URL}/api/ring/${door.id}`, updatedDoor)
      .then(() => {
        setDoor(updatedDoor);
        closeCard();
      })
      .catch((error) => console.error(error));
  };

  return (
    <Layout>
      <Container maxWidth={false} disableGutters>
        <Grid container spacing={2}>
          <Detail
            inputNameRef={inputNameRef}
            door={door}
            doorName={doorName}
            mapRef={mapRef}
            doorLat={doorLat}
            doorLng={doorLng}
            locateQr={locateQr}
            syncDoor={syncDoor}
            handleNameChange={handleNameChange}
            canvasRef={canvasRef}
            closeCard={closeCard}
            handleChangeActive={handleChangeActive}
            switchRef={switchRef}
            intl={intl}
          />
        </Grid>
      </Container>
    </Layout>
  );
};

export default RingDetail;
